/**
 * 在HTML元素上设置自定义CSS变量
 * @param {HTMLElement} element - 要设置变量的HTML元素
 * @param {string} key - CSS变量名（带或不带"--"前缀）
 * @param {string} value - CSS变量的值
 */
export function setCssVar({
  element = document.documentElement,
  key,
  value,
}: {
  element?: HTMLElement;
  key: string;
  value: string | number;
}) {
  // 确保变量名以"--"开头
  const formattedName = key.startsWith("--") ? key : `--${key}`;
  // 在元素上设置CSS变量
  element?.style.setProperty(formattedName, String(value));
}

/**
 * 批量设置CSS变量
 * @param {HTMLElement} element - 要设置变量的HTML元素
 * @param {Object} variables - 包含变量名和值的对象
 */
export function setCssVars({
  element = document.documentElement,
  variables,
}: {
  element?: HTMLElement;
  variables: Record<string, string | number>;
}) {
  for (const [name, value] of Object.entries(variables)) {
    setCssVar({ element, key: name, value });
  }
}
/*
// 在根元素上设置CSS变量
setCssVar({
  key: '--primary-color',
  value: '#3498db'
});
// 在根元素上批量设置CSS变量
setCssVars({
  variables: {
    '--primary-color': '#3498db',
    '--secondary-color': '#2ecc71',
    '--font-size': '16px',
    '--border-radius': '4px',
    '--opacity': 0.9
  }
});*/
